import React, { useCallback, useState } from 'react';
import { SvgIcon } from 'src/ui/common/atoms/svg-icon';
import { Typography } from 'src/ui/common/atoms/typography';
import { useClearFilters, useIsFiltersApplied } from '../../hooks/use-explore-arts';
import { StyledAuthTrigger, StyledFilterContent, StyledFilterHeader } from './styles';

export const FilterItem: React.FC<{
    title: string;
    disabled?: boolean;
    changeHeight?: boolean;
    isActive?: boolean;
    openedByDefault?: boolean;
}> = ({ isActive, disabled, openedByDefault, title, children, changeHeight }) => {
    const [opened, setOpened] = useState(!!openedByDefault);
    const isFiltersApplied = useIsFiltersApplied('explore');
    const clearFilters = useClearFilters();

    const toggle = useCallback(() => setOpened((s) => !s), []);

    const clear = useCallback(() => {
        clearFilters();
    }, [clearFilters]);

    return (
        <div>
            <StyledFilterHeader
                changeHeight={changeHeight}
                alignItems="center"
                justifyContent="space-between"
                onClick={toggle}
                isActive={!!isActive}
                opened={opened}
            >
                <Typography size="sm" color={opened ? 'text' : 'gs100'} medium>
                    {title}
                </Typography>
                {disabled && isFiltersApplied && (
                    <StyledAuthTrigger onClick={clear} color="cyan600" variant="text" size="xs">
                        Clear Filters
                    </StyledAuthTrigger>
                )}
                {!disabled && (
                    <SvgIcon
                        width={16}
                        height={16}
                        variant="regular"
                        icon={opened ? 'chevronUp' : 'chevronDown'}
                        color={opened ? 'white' : '#B2B6B5'}
                    />
                )}
            </StyledFilterHeader>
            {!disabled && <StyledFilterContent opened={opened}>{children}</StyledFilterContent>}
        </div>
    );
};